export default __webpack_public_path__ + "static/media/goal.6d78380d.png";